import PtsSchemaCrudPage from "../../../components/PtsSchemaCrudPage";

const PROJECT_CLIENT_SETTING_SCHEMA_NAME = "PTS Project Client Setting";
const PROJECT_LOOKUP_FIELDS = ["select_project", "client_project", "project"];

const ProjectSettingPage = () => {
  return (
    <PtsSchemaCrudPage
      schemaName={PROJECT_CLIENT_SETTING_SCHEMA_NAME}
      pageTitle="Project Setting"
      pageDescription="Manage project client billing settings"
      entityName="Project Setting"
      projectLookupFields={PROJECT_LOOKUP_FIELDS}
      moveColumnsToEnd={["address"]}
      ensureListColumns={[{ field_name: "gst_no", field_title: "GST No" }]}
      placeColumnsAfter={{ gst_no: "gst" }}
      useOpenProjectListInForm
    />
  );
};

export default ProjectSettingPage;
